exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".talk-title[data-v-473a5ed9]{font-weight:600;margin-bottom:8px}.talk-item[data-v-473a5ed9]{padding:4px 8px}.talk-item[data-v-473a5ed9]:hover{background-color:#eee}.talk-item-selected[data-v-473a5ed9]{color:#ff5722}.channel-list[data-v-473a5ed9]{max-height:504px;overflow-y:auto}", ""]);

// exports
